import { render, staticRenderFns } from "./releaseNoteView.vue?vue&type=template&id=553b3b12"
import script from "./releaseNoteView.vue?vue&type=script&lang=ts"
export * from "./releaseNoteView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports